<label *ngIf="props.label" class="b-f-checkboxgroup-label">{{
  props.label
}}</label>
<div [class]="props.layout">
  <div
    *ngFor="let option of props.options; let i = index"
    class="b-f-checkboxgroup-checkbox-container"
    [class.basin-mr-3]="
      props.layout === 'horizontal' || props.layout === 'flexwrap'
    "
  >
    <p-checkbox
      [ngModel]="formControl.value[option.value]"
      binary="true"
      [label]="option.label"
      (onChange)="onChange(option.value, $event.checked)"
    ></p-checkbox>

    <div
      *ngIf="option.tooltip"
      class="symbol-info tooltip-icon"
      [pTooltip]="option.tooltip"
    ></div>
  </div>
</div>
